import React from 'react';
import noop from '../../../utils/noop';
import { getSrcSet } from '../../../DeviationViews/Dumbo/Image/_helpers';
import ZoomModal from '../../../DeviationViews/ZoomModal';
import { useFullview } from '../../../DeviationViews/Full/hooks/useFullview';
export const ZoomModalFromImageSource = ({ source, width, height, allowFullviewSrcsetForPngs = false, isZoomed, onExitZoomMode = noop })=>{
    const { srcFile, isPixel } = useFullview({
        stageWidth: width !== null && width !== void 0 ? width : 0,
        stageHeight: height !== null && height !== void 0 ? height : 0,
        source,
        allowFullviewSrcsetForPngs
    });
    return isZoomed && srcFile && /*#__PURE__*/ React.createElement(ZoomModal, {
        src: srcFile.src,
        srcSet: getSrcSet(source),
        width: srcFile.width,
        height: srcFile.height,
        isPixel: !!isPixel,
        onClose: ()=>onExitZoomMode(source)
    });
};
export default ZoomModalFromImageSource;

//# sourceMappingURL=ZoomModalFromImageSource.js.map